module.exports = __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/promo-banners/less-prep/dish@2x-511c8f0a902286841581ec4f64e41c0e.webp";